export default __webpack_public_path__ + "static/media/1361.9d086a51.jpg";